<template>
  <div id="footer">
    <div class="foot-content">
      <div class="foot-topmain">
        <div class="foot-link">
          <dl>
            <dt>
              <router-link to="Articles">公司新闻</router-link>
            </dt>
          </dl>
          <dl>
            <dt>
              <router-link to="">材料平台</router-link>
            </dt>
            <dd>
              <a href="http://caigou.szhuajian.cn/" target="_blank">供应商平台</a>
            </dd>
          </dl>
          <dl>
            <dt>
              <router-link to="">关于网站</router-link>
            </dt>
            <dd>
              <router-link to="">网站地图</router-link>
            </dd>
            <dd>
              <router-link to="">法律声明</router-link>
            </dd>
            <dd>
              <router-link to="">隐私条款</router-link>
            </dd>
          </dl>
          <dl>
            <dt>
                <img src="~@/common/imgs/wxCode.png" alt="微信公众号">
            </dt>
            <dd><span>微信公众号</span></dd>
          </dl>
          <dl>
            <dt>
                <img src="~@/common/imgs/pcCode.png" alt="官网">
            </dt>
            <dd><span>华剑股份官网</span></dd>
          </dl>
        </div>
      </div>
      <div class="foot-copyright">
        <p>粤ICP备06127537号  Copyright © 2017-2018 szhuajian.cn All Rights Reserved 本网站版权所有</p></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {
        input: ""
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue